<template>
  <div class="dashboard-promo-banner dashboard-promo-banner--timer" :class="{ open: isOpen }">
    <a :href="bannerLink" class="banner--content">
      <div class="banner-content-wrap">
        <div class="banner--content__left">
          <div class="promo">
            <div class="promo-intro">
              {{ $gettext('Early upgrade discount') }}.
            </div> 
            <div v-html="bannerMessage" />

            <!-- <div v-translate='{discount_amount: discountAmount}'>
              If you upgrade now you will get a <span class="banner-price-tag"><strong>%{discount_amount} EUR</strong></span> discount on your yearly plan.
            </div> -->
          </div>
        </div>
        <div class="banner--content__right">
          <div class="flip-count">
            <span class="flip-title">{{ $gettext('Discount available until') }}</span>
            <FlipCount :time-until="promoEnds" />
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import FlipCount from "@/components/dashboard/ui/FlipCount"
import moment from 'moment';
export default {
  name: "PromoBannerEarly",
  components: {
    FlipCount
  },
  props: {
    promoData: {
      type: Object,
      default: () => {}
    },
    userName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isOpen: false,
      promoEnds: null,
      bannerType: null,
      debug: false
    }
  },
  computed: {
    ...mapGetters ({ 
      preferredLanguage: 'main/getPreferredLanguage'
    }),
    bannerLink () {
      return '/subscriptions/manage/?selected=year'
    },
    discountAmount () {
      return (this.promoData && this.promoData.discount && this.promoData.discount.amount) ? this.promoData.discount.amount : ""
    },
    bannerMessage () {
      return (this.promoData && this.promoData.discount && this.promoData.discount.banner_message) ? this.promoData.discount.banner_message : ""
    }
  },
  created () {
    if (this.promoData) {
      let dateformat = (this.preferredLanguage === 'en') ? 'MM/DD/YYYY' : 'DD/MM/YYYY'
      this.promoEnds = moment(this.promoData.end_time).add(1, 'days').format(dateformat)
    }
  },
  mounted () {
    setTimeout(() => {
      this.isOpen = true
    }, 1000)
  },
  methods: {
    
  }
}
</script>
<style lang="scss">
</style>
